import React, { Fragment, ReactNode, useEffect, useState } from 'react';
import { animateScroll as scroll } from 'react-scroll/modules';

import { fetchUnavailable, fetchUserSession } from '../actions';
import { StringKeyValue } from '../actions/types';
import Loader from '../components/Loader/Loader';
import { useAppDispatch, useAppSelector } from '../hooks/redux';
import { LoaderReducer } from '../reducers/loader';

interface Props {
    children: ReactNode;
    secure: boolean;
    key: string;
}

const GlobalLoader: React.FC<Props> = ({ children, secure, key }) => {
    const dispatch = useAppDispatch();
    const text = useAppSelector((s) => s.context.config.data.text as StringKeyValue);
    const loader = useAppSelector((s) => s.loader as LoaderReducer);
    const [hasCheckedUnavailable, setHasCheckedUnavailable] = useState(false);

    useEffect(() => {
        let active = true;

        const load = async () => {
            scroll.scrollToTop();

            const isUnavailable = await dispatch(fetchUnavailable());
            if (!active) return;

            setHasCheckedUnavailable(true);

            if (!isUnavailable && secure) {
                dispatch(fetchUserSession());
            }
        };

        void load();

        return () => {
            active = false;
        };
    }, [dispatch, secure]);

    const loaders = [
        {
            isLoading: !hasCheckedUnavailable,
            title: text.loadingDefault,
        },
        {
            isLoading: secure && !loader.isLoggedIn,
            title: text.loadingDefault,
        },
        {
            isLoading: loader.isFetchingUserSession,
            title: text.loadingUser,
        },
        {
            isLoading: loader.isFetchingUserContext,
            title: text.loadingUser,
        },
        {
            isLoading: loader.isFetchingProducts,
            title: text.loadingProducts,
        },
    ];

    for (const i in loaders) {
        if (loaders[i].isLoading) return <Loader title={loaders[i].title} />;
    }
    return <Fragment key={key}>{children}</Fragment>;
};

export default GlobalLoader;
